module.exports = __webpack_public_path__ + "688dedbbd03b0f8f5fa83e972a2c33bb.svg";